/* ==========================================================================
   BRASSLUXE MOROCCO — header (ES module)
   - Toggles .is-scrolled on [data-site-header] (transparent → frosted bar).
   - Mobile menu drawer: open/close, Esc, backdrop, aria-expanded, focus
     return, scroll-lock (page + Lenis).
   ========================================================================== */

const BLX = window.BrassLuxe || {};

function setupHeader(root) {
  const header = root.querySelector('[data-site-header]');
  const menu = root.querySelector('[data-mobile-menu]');
  const toggle = root.querySelector('[data-menu-toggle]');
  if (!header) return undefined;

  /* ---------- scroll state ---------- */
  function onScroll() {
    header.classList.toggle('is-scrolled', window.scrollY > 24);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- mobile menu drawer ---------- */
  if (!menu || !toggle) {
    return () => window.removeEventListener('scroll', onScroll);
  }

  const panel = menu.querySelector('.mobile-menu__panel');
  let isOpen = false;
  let lastFocus = null;

  function lockScroll(lock) {
    document.body.style.overflow = lock ? 'hidden' : '';
    if (BLX.lenis) {
      if (lock) BLX.lenis.stop();
      else BLX.lenis.start();
    }
  }

  function openMenu() {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    lockScroll(true);
    if (panel) panel.focus({ preventScroll: true });
    document.addEventListener('keydown', onKeydown);
  }

  function closeMenu() {
    if (!isOpen) return;
    isOpen = false;
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    lockScroll(false);
    document.removeEventListener('keydown', onKeydown);
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus({ preventScroll: true });
    }
  }

  function onKeydown(event) {
    if (event.key === 'Escape') { closeMenu(); return; }
    if (event.key !== 'Tab' || !panel) return;
    const focusables = panel.querySelectorAll(
      'a[href], button:not([disabled]), summary, input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function onClick(event) {
    if (event.target.closest('[data-menu-toggle]')) {
      event.preventDefault();
      if (isOpen) closeMenu(); else openMenu();
      return;
    }
    if (event.target.closest('[data-menu-close]')) {
      event.preventDefault();
      closeMenu();
    }
  }

  root.addEventListener('click', onClick);

  return function cleanup() {
    window.removeEventListener('scroll', onScroll);
    root.removeEventListener('click', onClick);
    document.removeEventListener('keydown', onKeydown);
    if (isOpen) closeMenu();
  };
}

if (typeof BLX.mount === 'function') {
  BLX.mount('[data-header-section]', setupHeader);
} else {
  document.querySelectorAll('[data-header-section]').forEach(setupHeader);
}
